import { Avatar, Box, SxProps, Theme } from '@mui/material';
import { Link } from 'react-router-dom';

const Logo = (props: { sx?: SxProps<Theme> }) => {
  return (
    <Box {...props}>
      <Link to="/login">
        <Avatar
          src={'/static/images/logo/AppLogo.png'}
          variant='rounded'
          sx={{ width: "200px", height:50}}
          slotProps={{ img: { style: { objectFit: "contain", width: "100%", height: "100%" }}}}
        ></Avatar>
      </Link>
    </Box>
  );
}

export default Logo;
